import { Component, RefObject } from "react"
import TextField from "@mui/material/TextField"

export interface InputProps {
    name: string
    placeholder?: string
    type?: string
    inputRef: RefObject<HTMLInputElement>
    styles?: {
        fontSize: React.CSSProperties
        color: React.CSSProperties
    }
}

class Input extends Component<InputProps> {
    
    render() {
        const { name, placeholder, type, inputRef } = this.props
        return (
            <TextField
                required
                InputProps={{ style: this.props.styles?.fontSize }}
                InputLabelProps={{ style: this.props.styles?.color }}
                id={name}
                label={placeholder}
                type={type}
                fullWidth={true}
                variant="outlined"
                inputRef={inputRef}
            />
        )
    }
}

export default Input